import {LitElement} from 'lit';
import {html} from 'lit/html.js';

import '@polymer/app-layout'
import '@polymer/iron-icon'
import '@polymer/paper-button'

import '@polymer/iron-location/iron-location';
import '@polymer/iron-selector/iron-selector';

import css from './tt-app.pcss';
// precache
import '../tt-page-loading/tt-page-loading'
import '../tt-page-gamelist/tt-page-gamelist'
import '../tt-page-error/tt-page-error'
// common
import '../tt-icons/tt-icons'
import '../tt-build-info/tt-build-info'

import {onMessage} from "firebase/messaging";

import {initializeApp} from "firebase/app"

const firebaseApp = initializeApp(FIREBASE.config);

import {TTUtil} from "../../utils/tt-util";
import {TTAppState} from "../../utils/tt-app-state";
import {TTAppStatemachine} from "../../utils/tt-app-statemachine";
import {TTAuthApi} from "../../utils/tt-auth-api";
import DevModule from "../../modules/dev";

// dayjs
import * as dayjs from "dayjs";
import LocalizedFormatPlugin from "dayjs/plugin/localizedFormat";
import UTCPlugin from "dayjs/plugin/utc";
import RelativeTimePlugin from "dayjs/plugin/relativeTime";
import 'dayjs/locale/de'

export default class TTApp extends LitElement {
    static get properties() {
        return {
            user: {
                type: Object
            },
            state: {
                type: Object
            }
        };
    }

    static get styles() {
        return [css];
    }

    constructor() {
        super();

        // dayjs config
        dayjs.extend(UTCPlugin)
        dayjs.extend(LocalizedFormatPlugin)
        dayjs.extend(RelativeTimePlugin)
        dayjs.locale('de')

        this.state = TTAppState.initial();
        this.stateMachine = new TTAppStatemachine(this);

        this.authApi = TTAuthApi.get(firebaseApp)
        this.authApi.onAuthStateChanged = (user) => {
            this.stateMachine.user(user)
        }

        if (FIREBASE_PERF) {
            new DevModule().initializePerformance(firebaseApp)
        }

        // messaging
        TTUtil.withMessaging((messaging) => {
            onMessage(messaging, (payload) => {
                console.log("Message received. ", payload);
            });
        });

        // TODO handle no internet connection
    }

    render() {
        document.title = this.state.data?.title ? this.state.data?.title : "";

        return html`
<iron-location @path-changed=${this.onPathChanged}></iron-location>

<app-drawer-layout responsive-width="1020px">
    <app-drawer id="drawer" slot="drawer">
        ${this.renderDrawerContent()}
    </app-drawer>

    <!-- main content -->
    ${this.renderMain()}

</app-drawer-layout>

<div id="dialogContainer"></div>
        `;
    }

    renderDrawerContent() {
        return html`
            <div class="drawer-container">
                <app-toolbar>Menü</app-toolbar>
                <iron-selector selected=${this.state?.data?.menu}
                               attr-for-selected="name"
                               class="drawer-list"
                               role="navigation">
                    <a class="link-list" name="Liveticker" href="/">Liveticker</a>
                    <a class="link-list" name="Community" href="/community">Community</a>
                </iron-selector>

                ${this.renderAdmin()}

                <div class="spacer"></div>

                <div class="drawer-list">
                    <a href="mailto:fabian.kajzar@tt-news.de?subject=TT-Liveticker">
                        <iron-icon icon="feedback"></iron-icon>
                        &nbsp;Feedback</a>
                    <a href="http://liveticker.tt-news.de/impressum.php">
                        <iron-icon icon="info"></iron-icon>
                        &nbsp;Impressum</a>
                </div>
            </div>
        `;
    }

    renderMain() {
        switch (this.state.type) {
            case "loading":
                return html`
                    <tt-page-loading id="page" .user=${this.user} />`;
            case "login-required":
                return html`
                    <tt-page-community-login .user=${this.user} />`;
            case "error":
                return html`
                    <tt-page-error id="page" .user=${this.user} .data=${this.state.data} />`;
            case "page":
                switch (this.state.data.type) {
                    case "gamelist":
                        return html`
                            <tt-page-gamelist id="page" .user=${this.user} .data=${this.state.data.data} /> `;
                    case "game":
                        return html`
                            <tt-page-game id="page" .user=${this.user} .data=${this.state.data.data} /> `;
                    case "community-list":
                        return html`
                            <tt-page-community-list id="page" .user=${this.user} />`;
                    case "community-reporter":
                        return html`
                            <tt-page-community-reporter id="page" .user=${this.user} .data=${this.state.data.data} />`;
                    case "league":
                        return html`
                            <tt-page-league id="page" .user=${this.user} .data=${this.state.data.data} />`;
                    case "club":
                        return html`
                            <tt-page-club id="page" .user=${this.user} .data=${this.state.data.data} />`;
                    case "admin":
                        return html`
                            <tt-page-admin id="page" .user=${this.user} .data=${this.state.data.data} />`;
                    case "admin-games":
                        return html`
                            <tt-page-admin-games id="page" .user=${this.user} .data=${this.state.data.data} />`;
                    case "admin-leagues":
                        return html`
                            <tt-page-admin-leagues id="page" .user=${this.user} .data=${this.state.data.data} />`;
                }
                throw Error("Unknown Page: " + this.state.data.type)
        }

        throw Error("Unknown type: " + this.state.type)
    }

    renderAdmin() {
        if (this._isAdmin()) {
            return html`
                <app-toolbar>Admin</app-toolbar>

                <iron-selector selected=${this.state?.data?.menu} 
                               attr-for-selected="name"
                               class="drawer-list"
                               role="navigation">
                    <a name="Sonstiges" href="/admin">Swagger UI</a>
                    <a name="Ligen" href="/admin-leagues">Ligen</a>
                    <a name="Admin-Games" href="/admin-games">Admin-Games</a>
                </iron-selector>

                <tt-build-info></tt-build-info>
        `;
        }
    }

    onPathChanged(evt) {
        let path = evt.detail.value;

        // report pageview
        TTUtil.withAnalytics(() => {
            ga('send', 'pageview', this.path);
        });

        this.stateMachine.to(path);

        // close drawer if open
        this.closeDrawer();
    }

    refreshCurrent() {
        this.stateMachine.to(window.location.pathname);
    }

    openDrawer() {
        this.shadowRoot.getElementById("drawer").open();
    }

    closeDrawer() {
        // close drawer if open
        if (!this.shadowRoot.getElementById("drawer").persistent) {
            this.shadowRoot.getElementById("drawer").close();
        }
    }

    navigateTo(url) {
        window.history.pushState({}, null, url);
        window.dispatchEvent(new CustomEvent('location-changed'));
    }

    navigateBack() {
        if (window.history.length < 3) {
            /* no history, e.g. when directly opening page with back button */
            window.history.replaceState({}, null, "/");
            window.dispatchEvent(new CustomEvent('location-changed'));
        } else {
            window.history.back();
        }
    }

    login() {
        this.authApi.login()
    }

    logout() {
        this.authApi.logout()
    }

    // used in tests
    _injectMessage(payload){
        TTUtil.withMessaging((messaging) => {
            console.log('Injecting Message...', payload);
            messaging.onMessageHandler(payload);
        });
    }

    _isAdmin() {
        return this.user && this.user.email === 'fabiankajzar@gmail.com' && this.user.emailVerified;
    }

}

window.customElements.define('tt-app', TTApp);
